import React from 'react';
import { SOCIAL_LINKS, TOKEN_INFO, CA_ADDRESS, EXPLORER_URL } from '../../config/constants';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Brand Column */}
                <div className="footer-brand-col">
                    <div className="footer-brand-row">
                        <img src="/images/logo.png" alt="Duck Logo" className="footer-logo" />
                        <span className="footer-brand">{TOKEN_INFO.symbol}</span>
                    </div>
                    <p className="footer-tagline">
                        The most unhinged aquatic bird on the Monad network.
                        Born in the ponds of nad.fun.
                    </p>
                    <div className="footer-social-icons">
                        <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noreferrer" className="footer-social-icon" aria-label="Twitter">
                            𝕏
                        </a>
                        <a href={SOCIAL_LINKS.telegram} target="_blank" rel="noreferrer" className="footer-social-icon" aria-label="Telegram">
                            ✈️
                        </a>
                        <a href={SOCIAL_LINKS.nadfun} target="_blank" rel="noreferrer" className="footer-social-icon" aria-label="Nad.fun">
                            🏊
                        </a>
                    </div>
                </div>

                {/* Quick Links */}
                <div className="footer-links-col">
                    <h4 className="footer-col-title">Quick Links</h4>
                    <a href="/#about" className="footer-link">About</a>
                    <a href="/#story" className="footer-link">Story</a>
                    <a href="/#how-to-buy" className="footer-link">How to Buy</a>
                    <a href="/#roadmap" className="footer-link">Roadmap</a>
                    <a href="/#faq" className="footer-link">FAQ</a>
                </div>

                {/* Resources */}
                <div className="footer-links-col">
                    <h4 className="footer-col-title">Resources</h4>
                    <a href={SOCIAL_LINKS.nadfun} target="_blank" rel="noreferrer" className="footer-link">Trade on nad.fun</a>
                    <a href={`${EXPLORER_URL}/address/${CA_ADDRESS}`} target="_blank" rel="noreferrer" className="footer-link">Contract on MonadScan</a>
                    <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noreferrer" className="footer-link">Latest Updates</a>
                </div>

                {/* Contract Info */}
                <div className="footer-links-col">
                    <h4 className="footer-col-title">Contract</h4>
                    <div className="footer-ca">
                        <span className="footer-ca-label">CA:</span>
                        <span className="footer-ca-address">{CA_ADDRESS.slice(0, 6)}...{CA_ADDRESS.slice(-4)}</span>
                    </div>
                    <div className="footer-network-badge">
                        <img src="/images/mon.svg" alt="Monad" className="footer-network-icon" />
                        <span>Monad Network</span>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <div className="footer-bottom-inner">
                    <p className="footer-copyright">
                        © 2025 $DUCK on Monad. All quacks reserved. 🦆
                    </p>
                    <p className="footer-disclaimer">
                        {TOKEN_INFO.symbol} is a memecoin with no intrinsic value or expectation of financial return.
                        Trading memecoins involves significant risk. DYOR. Not financial advice.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
